var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{staticClass:"ml-16",attrs:{"name":_vm.name_property,"label":"回答を入力","required":""},model:{value:(_vm.datas.saveValue),callback:function ($$v) {_vm.$set(_vm.datas, "saveValue", $$v)},expression:"datas.saveValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }